// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AccountResource,
  DeprecatedApiService,
  OrganizationHelpers,
  OrganizationResource,
  ScimTokenResource,
} from '@mode/legacy/data-access-model-js';
import { getCurrentUsername } from '@mode/shared/util-js';
import { WorkspaceSettingsDomainFacade } from '@mode/workspace-settings/domain';

/**
 *
 * This feature service handles the orchestration of core
 * webapp models and services for the Org Settings Module
 *
 * @todo move to a data-access service and facade pattern
 */
export class OrgSettingsService {
  static $inject = ['$q', 'AccountModel', 'ApiService', 'WorkspaceSettingsDomainFacade'];

  constructor(
    private $q: angular.IQService,
    private AccountModel: any,
    private apiService: DeprecatedApiService,
    private workspaceSettingsDomainFacade: WorkspaceSettingsDomainFacade
  ) {}

  /**
   *
   * Retrieve the account resource for the current user from
   * the model layer
   */
  public currentUser(): Promise<AccountResource> {
    return this.accountModelFetchResource({
      username: this.getCurrentUsername(),
      useEntryPath: true,
    });
  }

  public getCurrentUsername() {
    return getCurrentUsername(window.document);
  }

  /**
   *
   * Retrieve and extract the {@link AccountResource} response from API
   */
  public accountModelFetchResource<T extends AccountResource | OrganizationResource>(params: Object): Promise<T> {
    return this.accountModelFetch<T>(params).then((model) => model._resource);
  }

  /**
   *
   * Request account model from the model layer
   */
  public accountModelFetch<T extends AccountResource | OrganizationResource>(
    params: Object
  ): Promise<{ _resource: T }> {
    return this.AccountModel.find(params);
  }

  /**
   *
   * Fetch current owner organization from the model layer
   */
  public currentOrganization(configObj = {}): Promise<{ _resource: OrganizationResource }> {
    return this.workspaceSettingsDomainFacade.currentOrganization(configObj, this.AccountModel);
  }

  /**
   *
   * Extract owner org username from URL
   */
  public getOrgUsername() {
    return this.workspaceSettingsDomainFacade.getCurrentOrgUsername();
  }

  public getScimToken(organization: OrganizationResource): angular.IPromise<ScimTokenResource | null> {
    if (OrganizationHelpers.hasScimToken(organization)) {
      return this.apiService.getResource<ScimTokenResource>(organization, 'scim_token');
    } else {
      return this.$q.resolve(null);
    }
  }
}
